module.exports = __webpack_public_path__ + "img/c08_buildingtechelephantmastery_Normal_ua.0ec2ed5b.webp";